(function($) {

	morePostsLoader = {
		init: function () {
			this.fetch_news_posts();
		},
		fetch_news_posts: function() {

			// Get number of posts in container
			var posts_container = $('#articles-container');

			posts_container.each(function() {
				var $this = $(this),
					numberposts = $this.attr('data-numberposts'),
					currentposts = $this.children();

				// Show load more button if there are more posts to fetch;
				if(currentposts.length < numberposts) {
					$this.parent().parent().find($('.more-wrapper')).show();
				}
			});

			// On "Load More Posts" click...
			$('.load-more-news').on('click', function(event) {
				event.preventDefault();
				// Pass it to ajaxLoadcontent
				ajaxLoadContent(posts_container);
			});

			function ajaxLoadContent(target_list) {
				// get the post type from the container list
				var post_type = target_list.attr('data-posttype');
				// grab the category id from the container list if it exists
				var category_id = target_list.attr('data-categoryid');
				// Unbind load-more-news while we fetch the new content:
				$('.load-more-news').off('click');
				// Get total number of posts on container and update variables if neccessary
				var item_list = target_list;
				var numberposts = item_list.attr('data-numberposts');
				var currentposts = target_list.children('li');
				// Indicate loading
				item_list.addClass('loading');
				// Set up an array to store the post IDs:
				var excluded_ids = [];
				// Loop through the posts on the page and store each post ID in the array excluded_ids.
				target_list.children('li').each(function(){
					var id = $(this).attr('data-postid'); // the value of the data-postid attribute of the post
					excluded_ids.push(id); // adding each ID to the array of posts to exclude
				});
				var fetchedposts = excluded_ids.length;
				// Check we haven't fetched all posts
				if( fetchedposts < numberposts ){
					// Ajax request for the new content - fetches it from the get_more_content() function in functions.php
					var content_ajax = $.ajax({
						url: ajaxurl,
						data: {
							'action': 'get_more_content',
							'excluded_ids': excluded_ids,
							'post_type': post_type,
							'category_id': category_id
						},

						// If AJAX request was successful:
						success:function(data) {

							// Get the temporary container for the returned data (fetched posts):
							var temp_container = item_list.siblings('.ajax-content');

							// Populate it:
							temp_container.append(data);
							var lastInList = target_list.children('li').last().get(0);
							console.log(lastInList);
							target_list.append(data);

							// Update number returned posts
							fetchedposts += temp_container.children('li').length;

							// Re-enable ajax.posts; we turned it off at the beginning of this function:
							morePostsLoader.fetch_news_posts();

							item_list.removeClass('loading');

							// temp_container.children('li').unwrap();
							temp_container.empty();

							var loadMoreButton = $('.load-more-news');

							loadMoreButton.insertAfter(temp_container);

							// Remove load more button if there are no more posts to fetch:
							if(fetchedposts  == numberposts ){
								loadMoreButton.hide();
							}

							// get last item in list
							lastInList.scrollTo({
								top: 0,
								left: 0,
								behavior: "smooth",
							});

						},

						// If AJAX request failed:
						error: function(errorThrown){
							console.log(errorThrown);
						}
					});
				}
			}
		}
	};

})( jQuery );

(function($) {
	services = {
		init: function () {
			articles_container = $('#articles-container ul'); // inefficient jquery usage apparently
			services.filter_services();
		},
		filter_services: function () {

			// Go through the service submenu
			$(document).on('tap.filterServices', '.services-list li a', function (event) {

				event.preventDefault();

				var parent_post_id = $(this).attr('data-postterm');


				var load_services_ajax = $.ajax({
						url: ajaxurl,
						data: {
							'action':'ajax_service_articles',
							'html':'',
							'child_post_id':child_post_id,
							'parent_post_id':parent_post_id

							//'excluded_ids':excluded_ids,
						},
						// If AJAX request was successful:
						success:function(data) {

							console.log(data);

						},

						// If AJAX request failed:
						error: function(errorThrown){
							console.log(errorThrown);
						}
					}
				);

			});

		}
	};

})( jQuery );

// document ready
(function($) {

	$(document).ready(function(){

		$('[data-slider]').slick({
			arrows : true,
			autoplay: false,
			autoplaySpeed: 5000,
			dots: true,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						arrows: false
					}
				}
			]
		});

		// Load More Posts
		morePostsLoader.init();

		//desktop services nav toggle
		$(".services-link").click(function(e){
			// disable click functionality on hovered item.
			e.preventDefault();
		});
		//desktop services nav toggle
		$(".pricing-link").click(function(e){
			// disable click functionality on hovered item.
			e.preventDefault();
		});

		function setupTopnav() {
			$('.mega-menu').hide();

			// unbind old events
			$('.service-menu-item, .about-nav-item, #servicesmega, #pricingmega, #aboutmega, #blogmega, .about-link, .services-link, .pricing-link, .blog-link').off('click');
			$('.service-menu-item, .about-nav-item, #servicesmega, #pricingmega, #aboutmega, #blogmega, .about-link, .services-link, .pricing-link, .blog-link').off('mouseover');
			$('.service-menu-item, .about-nav-item, #servicesmega, #pricingmega, #aboutmega, #blogmega, .about-link, .services-link, .pricing-link, .blog-link').off('mouseout');

			// mobile menu init
			if (window.matchMedia("(max-width: 1099px)").matches) {
				// show the dropdown if not shown
				$(".services-link").on('click', function (e) {
					e.preventDefault();
					if ($(this).hasClass('show')) {
						$(this).removeClass("show");
						$(this).siblings(".sub-nav").removeClass("show");
					} else {
						$(this).addClass("show");
						$(this).siblings(".sub-nav").addClass("show");
					}
				});
				// show the dropdown if not shown
				$(".pricing-link").on('click', function(e) {
					e.preventDefault();
					if($(this).hasClass('show')) {
						$(this).removeClass("show");
						$(this).siblings(".sub-nav").removeClass("show");
					} else {
						$(this).addClass("show");
						$(this).siblings(".sub-nav").addClass("show");
					}
				});
				// show the dropdown if not shown
				$(".about-link").on('click', function(e) {
					e.preventDefault();
					if($(this).hasClass('show')) {
						$(this).removeClass("show");
						$(this).siblings(".sub-nav").removeClass("show");
					} else {
						$(this).addClass("show");
						$(this).siblings(".sub-nav").addClass("show");
					}
				});
			} else {
				// desktop mega menu inits
				// services
				$(".service-menu-item, #servicesmega").mouseover(function () {
					$('#servicesmega').show();
				});
				$(".service-menu-item, #servicesmega").mouseout(function () {
					$('#servicesmega').hide();
				});
				// about
				$(".about-nav-item, #aboutmega").mouseover(function () {
					$('#aboutmega').show();
				});
				$(".about-nav-item, #aboutmega").mouseout(function () {
					$('#aboutmega').hide();
				});
				// pricing
				$(".pricing-menu-item, #pricingmega").mouseover(function () {
					$('#pricingmega').show();
				});
				$(".pricing-menu-item, #pricingmega").mouseout(function () {
					$('#pricingmega').hide();
				});
				// blog
				$(".blog-menu-item, #blogmega").mouseover(function () {
					$('#blogmega').show();
				});
				$(".blog-menu-item, #blogmega").mouseout(function () {
					$('#blogmega').hide();
				});
			}
		}
		setupTopnav();
		$(window).resize(function() {
			setupTopnav();
		});

		function wireUpMobileMenu() {
			if (window.matchMedia("(max-width: 1099px)").matches) {
				$('li.menu-item-has-children .nav-dropdown-icon, li.service-with-children .nav-dropdown-icon').on('click', function (e) {
					var parent = $(this).closest('li.service-with-children, li.menu-item-has-children');
					var hadClass = parent.hasClass('show');
					// turn off all the others
					$('.nav-dropdown-icon').removeClass('show');
					$('li.service-with-children, li.menu-item-has-children').removeClass('show');
					$('li.service-with-children, li.menu-item-has-children').find('.nav-icon, .sub-menu').removeClass('show');
					if (hadClass) {
					} else {
						// turn on the new one
						$(this).addClass('show');
						$(this).children('.nav-icon').addClass('show');
						parent.addClass('show');
						parent.children('.sub-menu').addClass('show');
					}
				});
			} else {
				$('li.menu-item-has-children .nav-dropdown-icon, li.service-with-children .nav-dropdown-icon').off('click');
			}
		}
		wireUpMobileMenu();

		// mobile nav toggle
		$(".toggle-nav").click(function(e) {
			e.preventDefault();
			$(this).toggleClass("show");
			$(".main-nav").toggleClass("show");
		});

		// toggle collapsable lists
		$(".js-section-toggle").click(function(e) {
			e.preventDefault();
			//$(this).toggleClass("open");
			$(this).closest(".collapsable-parent").toggleClass("open");
		});

		$('figure.quote').each(function() {
			var moreBlock = $(this).find('.more');
			if(moreBlock) {
				moreBlock.hide();
				$(this).find('a.readless').hide();
				// bind trigger
				$(this).find('a.readmore').on('click', function (e) {
					e.preventDefault();
					moreBlock.slideDown('fast');
					$(this).hide();
					$(this).siblings('a.readless').show();
				});
				// bind trigger
				$(this).find('a.readless').on('click', function (e) {
					e.preventDefault();
					moreBlock.slideUp('fast');
					$(this).hide();
					$(this).siblings('a.readmore').show();
				});
			}
		});

		//fix menus
		$('.filter-sidebar').stick_in_parent({
			recalc_every: 1,
			offset_top: 100
		});

		$(".is-child-page").click(function(e) {
			e.preventDefault();
		});

		$("header.site-header").stick_in_parent();

		// make share popups look a bit nicer than just a new window
		$('.popup-link').click(function(e) {
			e.preventDefault();
			var width  = 575,
				height = 400,
				left   = ($(window).width()  - width)  / 2,
				top    = ($(window).height() - height) / 2,
				url    = this.href,
				opts   = 'status=1' +
					',width='  + width  +
					',height=' + height +
					',top='    + top    +
					',left='   + left;

			window.open(url, 'twitter', opts);
		});

		function resizeVideos() {
			// Responsive youtube videos (width/height in css)
			var $allVideos = $('iframe[src*="youtube"]');
			$allVideos.each(function() {

				var orig_h = $(this).attr('height'),
					orig_w = $(this).attr('width'),
					aspect = orig_h/orig_w,
					new_h = $(this).parent().width() * aspect,
					new_w = $(this).parent().width();

				$(this).attr('height', new_h).attr('width', new_w);
			});

		}
		resizeVideos();

		$(window).resize(function() {
			resizeVideos();
		});

		document.addEventListener("scroll", doScrolling, false);

		function doScrolling() {
			var scrolled = $(window).scrollTop();

			//auto hide mobile menu on scroll
			if(scrolled > 200)
			{
				//$(".main-nav").removeClass("show");
				//$(".toggle-nav").removeClass("show");
			}
		}

		function equalizeHeights() {
			// equalize heights of cards in wp-block-columns
			if (window.matchMedia("(min-width: 764px)").matches) {
				var maxCardHeight = 0;
				$('.wp-block-columns').each(function () {
					var cards = $(this).find('.wp-block-shcblocks-linked-icon-box > a, .wp-block-shcblocks-linked-card > a, div.wp-block-shcblocks-card');
					cards.each(function () {
						if ($(this).height() >= maxCardHeight) {
							maxCardHeight = $(this).height();
						}
						$(this).height('auto');
					});
					cards.each(function () {
						$(this).height(maxCardHeight);
					});
				});
			}
		}
		equalizeHeights();
		$(window).resize(function() {
			equalizeHeights();
		});

		// accordion
		$('.wp-block-shcblocks-accordion').each(function() {
			$(this).find('.clickable').each(function() {
				$(this).append('<span class="icon">+</span>');
				$(this).attr('rel', 'closed');
			});
			$(this).find('.clickable').on('click', function () {
				if($(this).attr('rel') === "closed") {
					$(this).attr('rel', 'open');
					$(this).find('.icon').html('-');
					$(this).siblings('.expandedcontent').show();
				} else {
					$(this).attr('rel', 'closed');
					$(this).find('.icon').html('+');
					$(this).siblings('.expandedcontent').hide();
				}
			});
			// set closed
			$(this).find('.clickable').data('status', 'closed');
			$(this).find('.expandedcontent').hide();
		});

	});


	$(document).on('gform_post_render', function (event, formId, current_page) {

		$('#input_3_36').each(function() {
			var options = $(this).children('option');
			var i = 0;
			options.each(function() {
				var text = $(this).text();
				if(i > 0 && text.charAt(0) !== "—") {
					$(this).nextUntil(":not(option:contains('—'))").addBack().wrapAll(document.createElement('optgroup'));
				}
				i++;
			});
		});
	});

})( jQuery );

window.setTimeout(function () {
	jQuery('#gform_3 section').each(function() {
		if(jQuery(this).children(':visible').length == 0) {
			jQuery(this).remove();
		}
		else {
			console.log('nope');
		}
	});
}, 500);
